import * as React from 'react';
import { DayCalendar } from './calendar';
import { ViewProp } from '..';
import * as mrCap from '../../mrCapTypes';
import * as api from '../../api/booking';
import { PageIntro } from '../pageintro';
import GoogleMapReact from 'google-map-react';
import { Shop } from './shop';
import format from 'date-fns/format';
import sv from 'date-fns/locale/sv';
import { MabiRental } from './mabiRental';
import { className } from '../../util';
import { MapWithShops } from './map';

interface Props extends ViewProp {
}

interface State {
  shops: mrCap.Shop[];
  findShop: string;
  visibleShopList: boolean;
  bookableTimes: BookableTimes[];
}

export interface BookableTimes {
  start: Date;
  end: Date;
  title: string;
}

export class LocationDateSelection extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);

    this.state = {
      shops: [],
      visibleShopList: false,
      findShop: '',
      bookableTimes: []
    };
  }

  componentDidMount() {
    this.fetchShops();

    if (this.props.selectedShop) {
      const shopId = this.props.selectedShop.id;
      this.fetchTimes(shopId);
    }
  }

  async fetchShops() {
    const shops = await api.getShops();

    if (shops && shops.length) {
      this.setState({ shops });
    }
  }

  async fetchTimes(id: number) {

    this.setState({bookableTimes: []});
    this.props.setDate(null);

    const bookableTimes = await api.getShopTimes(id);
    bookableTimes.forEach(item => {
      let obj = {start: item, end: item, title: format(item, 'dd', {locale: sv}) };
      this.state.bookableTimes.push(obj);
    });
    this.setState({ visibleShopList: false });

  }

  findShops(value: string) {
    this.setState({ findShop: value });
  }

  render() {
    return (
      <div className='outer-page'>
        <div className='page'>

          <div className='page-top-content'>
            <PageIntro
              header={this.props.texts.stepTwoHeader}
              preamble={this.props.texts.stepTwoParagraph} />

            {this.props.regNr && this.props.carDetails && <>
              <div className="chosen-hint special">
                <strong><i className='fas fa-car'></i> Din bil: </strong>
                {this.props.regNr + ', ' + this.props.carDetails.brand + ' ' + this.props.carDetails.model}
              </div>
            </>}
          </div>

          <div className='page-split'>
            <div className='page-split-col left-col'>
              <MapWithShops
                {...this.props}
                shops={this.state.shops}
                updateTimes={id => this.fetchTimes(id)}
                shopChangedMessage={this.props.texts.stepTwoShopChangedMessage} />
            </div>

            <div className='page-split-col right-col'>
              {this.props.selectedShop && this.state.bookableTimes.length > 0 &&
                <DayCalendar
                  resourceTitle={this.props.selectedShop.name}
                  bookableTimes={this.state.bookableTimes}
                  selectDate={this.props.setDate} />}

              {this.props.selectedShop != null && this.state.bookableTimes.length === 0 && <>
                <div className='no-calendar'>
                  <div className='no-calendar-content'>
                    <i className='far fa-calendar-times'></i>
                    <span>Hittade inga lediga tider på vår anläggning i {this.props.selectedShop.name}</span>
                  </div>
                </div>
              </>}

              {this.props.selectedShop === null && <>
                <div className='no-calendar'>
                  <div className='no-calendar-content'>
                    <i className='far fa-calendar-check'></i>
                    <span>Välj anläggning för att välja datum</span>
                  </div>
                </div>
              </>}
              {this.props.selectedShop && <>
                <div className={className('chosen-hint', {active: this.props.selectedDate !== null} )}>
                  {this.props.selectedDate
                    ? <>
                      <div className='date'><strong>Valt datum: </strong>
                        {format(this.props.selectedDate, 'PPPP', {locale: sv}).toString()}
                      </div>
                    </>
                    : 'Inget datum valt ännu'}
                </div>
              </>}

              {this.props.mabi &&
                <MabiRental
                  {...this.props}
                  fridayMessage={this.props.texts.stepTwoRentalMessage} />}

            </div>
          </div>
        </div>
      </div>
    );
  }
}

interface MarkerProps {
  shop: mrCap.Shop;
  click: (shop: mrCap.Shop) => void;
  updateTimes: (id: number) => void;
  lat: number | undefined;
  lng: number | undefined;
}

export function Markers({shop, click, updateTimes}: MarkerProps) {

  const handleClick = () => {
    click(shop);
    updateTimes(shop.id);
  };

  return (
    <div className='marker'>
      <div className='marker-inner'
        onClick={handleClick}>
        <i className='fas fa-map-marker'></i>
      </div>
    </div>
  );
}